import { useLayoutEffect } from "react";

import { PREVIEW_ID } from "src/serverPreviewId";

export const hasServerPreview = () => !!document.getElementById(PREVIEW_ID);

export const removeServerPreview = () => {
  document.getElementById(PREVIEW_ID)?.remove();
  document.getElementById(`${PREVIEW_ID}-style`)?.remove();
};

// Layout effects run after the DOM commit and before paint, so the swap has no gap frame.
export const useServerPreviewUntilLoaded = (loading: boolean) => {
  useLayoutEffect(() => {
    if (!loading) removeServerPreview();
  }, [loading]);
  useLayoutEffect(() => removeServerPreview, []);
};
